import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';

import { gameLiveConnection } from '../../../services/socketConnection/gameConnection';

import { isMobile } from '../../../core/helpers/isMobile';

import { jackPotStore } from '../../../store/jackPotStore';
import { applicationStore } from '../../../store/applicationStore';
import { gameService } from '../../../services/gameService';
import { formatTime } from '../../../core/helpers/formatTime';

const ExpireDate = observer(({ x, y }) => {
  const { jackPotExpireTime, setIsAllowDoJackpotAction } = jackPotStore;

  useEffect(() => {
    gameService.sendWorker(jackPotExpireTime);
    return () => gameService.sendWorker();
  }, []);

  useEffect(() => {
    if (jackPotExpireTime === 0) {
      gameLiveConnection.getJackpotScene();
    }
  }, [jackPotExpireTime]);

  useEffect(() => {
    if (jackPotExpireTime < 3) {
      setIsAllowDoJackpotAction(false);
    }
  }, [jackPotExpireTime, setIsAllowDoJackpotAction]);

  return (
    <Container x={x} y={y} name='JackPotExpireTimeContainer'>
      <Text
        anchor={0.5}
        resolution={2}
        text={`${applicationStore.canvasTranslationKeys.EXPIRY} ${
          jackPotExpireTime > 0 ? formatTime(jackPotExpireTime) : '00:00'
        }`}
        style={{ fill: '#FFFFFF', fontSize: isMobile() ? 13 : 16 }}
      />
    </Container>
  );
});

export default ExpireDate;
